module.exports = __webpack_public_path__ + "static/media/wonders.0e753a71.jpg";